class CollectionGrid extends HTMLElement {
  constructor(){
    super();

    this._selectors = {
      productGrid: '[js-products-grid]',
      nextPage: '[js-collection-next-page]'
    }
  }

  connectedCallback() {
    this._productGrid = this.querySelector(this._selectors.productGrid);
    this._initInfiniteScroll();
  }


  _initInfiniteScroll = () => {
    const nextPage = this.querySelector(this._selectors.nextPage);

    if (!nextPage){
      return;
    }

    const options = {
      // whole screen is the scroll area
      root: null,
      //threshold 0-1.0, 0 is any pixel, 1.0 is all pixels must be in view area
      threshold: 1.0
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { 
          this._addProducts(nextPage);
        }
      })
    }, options)

    observer.observe(nextPage)
  }

  _addProducts = async (nextPage) => {
    const url = nextPage.dataset.url;
    const parsedHTML = await this._getProducts(url);
    const newHTML = parsedHTML.querySelector(this._selectors.productGrid)

    newHTML.querySelector('li.image-tout')?.remove()
    newHTML.querySelector('li.section-break')?.remove()

    const newProducts = newHTML.innerHTML

    const newNextPage = parsedHTML.querySelector(this._selectors.nextPage);
    this._productGrid.insertAdjacentHTML('beforeend', newProducts);
    if (newNextPage) {
      nextPage.setAttribute('data-url', newNextPage.getAttribute('data-url'));
    }else{
      nextPage.remove();
    }
  }

  _getProducts(url) {
    return fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        return parsedHTML;
      })
  }

}

customElements.define('collection-grid', CollectionGrid);